var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "水平排列方式" } },
        [
          _c(
            "el-select",
            {
              staticClass: "setting-grid-justify",
              model: {
                value: _vm.justify,
                callback: function($$v) {
                  _vm.justify = $$v
                },
                expression: "justify"
              }
            },
            [
              _c("el-option", { attrs: { value: "start", label: "左对齐" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "end", label: "右对齐" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "center", label: "居中" } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { value: "space-around", label: "两侧间隔相等" }
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { value: "space-between", label: "两端对齐" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bf482b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf482b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingGridJustify.vue
// module id = null
// module chunks = 